import { authHeader, handleResponse } from '../helpers';
export const mappingRptService = {
    fetchMappingData,
    fetchSalesPerson
};

function fetchMappingData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}SalesData/GetSalesDataReportResponse`, requestOptions)
        .then(handleResponse);
}
function fetchSalesPerson() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetUserNanme`, requestOptions)
        .then(handleResponse);
}